"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    UserPen: function() {
        return UserPen;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const UserPen = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M12 3C10.3431 3 9 4.34315 9 6C9 7.65685 10.3431 9 12 9C13.6569 9 15 7.65685 15 6C15 4.34315 13.6569 3 12 3ZM7 6C7 3.23858 9.23858 1 12 1C14.7614 1 17 3.23858 17 6C17 8.76142 14.7614 11 12 11C9.23858 11 7 8.76142 7 6ZM4.06189 21C4.55399 17.0537 7.92038 14 12 14C12.8952 14 13.7541 14.1467 14.5553 14.4165C15.0787 14.5928 15.6459 14.3114 15.8221 13.788C15.9984 13.2646 15.717 12.6974 15.1936 12.5211C14.1895 12.1829 13.1151 12 12 12C6.47715 12 2 16.4772 2 22C2 22.5523 2.44772 23 3 23H10C10.5523 23 11 22.5523 11 22C11 21.4477 10.5523 21 10 21H4.06189ZM18.2929 14.2929C19.2357 13.3501 20.7643 13.3501 21.7071 14.2929C22.6499 15.2357 22.6499 16.7643 21.7071 17.7071L17 22.4142C16.6249 22.7893 16.1162 23 15.5858 23H14C13.4477 23 13 22.5523 13 22V20.4142C13 19.8838 13.2107 19.3751 13.5858 19L18.2929 14.2929ZM20.2929 15.7071C20.1311 15.5453 19.8689 15.5453 19.7071 15.7071L15 20.4142V21H15.5858L20.2929 16.2929C20.4547 16.1311 20.4547 15.8689 20.2929 15.7071Z",
        fill: "currentColor"
    })
}), "UserPen");
const _default = UserPen;
